import { gql } from "@apollo/client"
import { GetCollectionGroupWithID, GetCollectionGroupWithID_getCollectionGroupWithID, GetCollectionGroupWithIDVariables } from "./types/GetCollectionGroupWithID"

export const GETCOLLECTIONGROUPWITHID_QUERY = gql`
  query GetCollectionGroupWithID($getCollectionGroupWithIdId: Int!) {
    getCollectionGroupWithID(id: $getCollectionGroupWithIdId) {
      error
      message
      id
      label
      district_id
      startDepot {
        id
        name
        latitude
        longitude
      }
      endDepot {
        id
        name
        latitude
        longitude
      }
      district {
        id
      }
      materials {
        id
      }
      ordered
      collection_points {
        id
        description
        street
        latitude
        longitude
        location_number
        cadastral_name
        cadastral_nr
        postal
        place
        town {
          id
          name
        }
        collection_groups {
          id
          label
          materials {
            id
          }
        }
      }
    }
  }
`

export type CollectionGroupWithIDResult = GetCollectionGroupWithID
export type CollectionGroupWithIDVariables = GetCollectionGroupWithIDVariables
export type CollectionGroupWithID = GetCollectionGroupWithID_getCollectionGroupWithID